import React from 'react';
import PropTypes from 'prop-types';
import QTIAssessmentItem from './QTIAssessmentItem';
import DrawingBlockContainer from './DrawingBlock';
import { t } from '../../services/i18nService';
import questionHelperServices from '../../services/questionView/QuestionHelperServices';
import styles from './QuestionDisplay.scss';

class QTIAssessmentItemWithDrawing extends React.PureComponent {
    static propTypes = {
        question: PropTypes.object.isRequired,
        userResponses: PropTypes.object.isRequired,
        callback: PropTypes.func.isRequired,
        isReadOnly: PropTypes.bool,
        isReadOnlyBasedOnManualSelectionSetup: PropTypes.bool,
        context: PropTypes.string.isRequired,
        correctResponses: PropTypes.object,
        currentScorableItem: PropTypes.number,
        direction: PropTypes.string.isRequired,
        onCanvasStateChange: PropTypes.func,
        flaggedItems: PropTypes.array,
        isCurrent: PropTypes.bool,
        questionInteractionVisibility: PropTypes.object,
        reportReady: PropTypes.func.isRequired,
        services: PropTypes.object.isRequired,
        settingValues: PropTypes.object,
        viewMedia: PropTypes.string,
        feedback: PropTypes.object,
        shouldShowInteractionFeedback: PropTypes.bool.isRequired,
        zoomFactor: PropTypes.string,
        outcomeVariables: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            canvasOpened: false,
            showQuestion: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { onCanvasStateChange } = this.props;
        const { canvasOpened, showQuestion } = this.state;
        // Only call the function if the state has changed
        if ((prevState.canvasOpened !== canvasOpened) || (prevState.showQuestion !== showQuestion)) {
            if (onCanvasStateChange) {
                const canvasState = {
                    canvasOpened,
                    showQuestion,
                };
                onCanvasStateChange(canvasState);
            }
        }
    }

    toggleQuestionVisibility = () => {
        this.setState(prevState => ({
            showQuestion: !prevState.showQuestion,
        }));
    };

    handleCanvasStateChange = (isCanvasOpen) => {
        this.setState(prevState => ({
            canvasOpened: isCanvasOpen,
            showQuestion: prevState.showQuestion,
        }));
    };

    render() {
        const {
            question,
            userResponses,
            callback,
            isReadOnly,
            isReadOnlyBasedOnManualSelectionSetup,
            context,
            correctResponses,
            currentScorableItem,
            direction,
            flaggedItems,
            isCurrent,
            questionInteractionVisibility,
            reportReady,
            services,
            settingValues,
            viewMedia,
            feedback,
            shouldShowInteractionFeedback,
            zoomFactor,
            outcomeVariables,
        } = this.props;

        const { canvasOpened, showQuestion } = this.state;

        return (
            <div className={styles.questionWithDrawingContainer}>
                {!canvasOpened && (
                    <QTIAssessmentItem
                        callback={callback}
                        context={context}
                        correctResponses={correctResponses}
                        currentScorableItem={currentScorableItem}
                        direction={direction}
                        flaggedItems={flaggedItems}
                        isCurrent={isCurrent}
                        isReadOnly={isReadOnly || isReadOnlyBasedOnManualSelectionSetup}
                        key={question.contentRevisionId}
                        outcomeVariables={outcomeVariables}
                        question={question}
                        questionInteractionVisibility={questionInteractionVisibility}
                        reportReady={reportReady}
                        services={services}
                        settingValues={settingValues}
                        userResponses={userResponses}
                        viewMedia={viewMedia}
                        feedback={feedback}
                        shouldShowInteractionFeedback={shouldShowInteractionFeedback}
                        zoomFactor={zoomFactor}
                    />
                )}

                {canvasOpened && (
                    <div
                        className={styles.drawingOverlay}
                    >
                        <div
                            className={styles.drawingOverlayContent}
                        >
                            <div className={styles.drawingOverlayCanvas}>
                                <DrawingBlockContainer
                                    question={question}
                                    userResponses={userResponses}
                                    handleUserResponse={callback}
                                    services={questionHelperServices.getServices()}
                                    isReadOnly={isReadOnly || isReadOnlyBasedOnManualSelectionSetup}
                                    onCanvasStateChange={this.handleCanvasStateChange}
                                    context={context}
                                    shouldAutoOpenCanvas
                                    showQuestionToggle={
                                        <button
                                            type="button"
                                            className={styles.hideQuestionButton}
                                            onClick={this.toggleQuestionVisibility}
                                        >
                                            <i className={`fa ${showQuestion ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden="true" />
                                            <span className={styles.toggleLabel}>
                                                {showQuestion ? t('interactions.drawing.hideQuestion') : t('interactions.drawing.showQuestion')}
                                            </span>
                                        </button>
                                    }
                                    questionContent={showQuestion ? (
                                        <QTIAssessmentItem
                                            callback={callback}
                                            context={context}
                                            correctResponses={correctResponses}
                                            currentScorableItem={currentScorableItem}
                                            direction={direction}
                                            flaggedItems={flaggedItems}
                                            isCurrent={isCurrent}
                                            isReadOnly={isReadOnly || isReadOnlyBasedOnManualSelectionSetup || canvasOpened}
                                            key={question.contentRevisionId}
                                            outcomeVariables={outcomeVariables}
                                            question={question}
                                            questionInteractionVisibility={questionInteractionVisibility}
                                            reportReady={reportReady}
                                            services={services}
                                            settingValues={settingValues}
                                            userResponses={userResponses}
                                            viewMedia={viewMedia}
                                            feedback={feedback}
                                            shouldShowInteractionFeedback={shouldShowInteractionFeedback}
                                            zoomFactor={zoomFactor}
                                        />
                                    ) : null}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {!canvasOpened && (
                    <DrawingBlockContainer
                        question={question}
                        userResponses={userResponses}
                        handleUserResponse={callback}
                        services={questionHelperServices.getServices()}
                        isReadOnly={isReadOnly || isReadOnlyBasedOnManualSelectionSetup}
                        onCanvasStateChange={this.handleCanvasStateChange}
                        context={context}
                    />
                )}
            </div>
        );
    }
}

export default QTIAssessmentItemWithDrawing;
